import { render, staticRenderFns } from "./TableNumberItem.vue?vue&type=template&id=016cf913&scoped=true"
import script from "./TableNumberItem.vue?vue&type=script&lang=js"
export * from "./TableNumberItem.vue?vue&type=script&lang=js"
import style0 from "./TableNumberItem.vue?vue&type=style&index=0&id=016cf913&scoped=true&lang=css"
import style1 from "./TableNumberItem.vue?vue&type=style&index=1&id=016cf913&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016cf913",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('016cf913')) {
      api.createRecord('016cf913', component.options)
    } else {
      api.reload('016cf913', component.options)
    }
    module.hot.accept("./TableNumberItem.vue?vue&type=template&id=016cf913&scoped=true", function () {
      api.rerender('016cf913', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/tableComp/tableItems/TableNumberItem.vue"
export default component.exports